// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.n-emblem-text {
  color: var(--emblem-content);
  line-height: normal;
  font-weight: 600;
}
.n-emblem-text--active {
  color: var(--emblem-content-active);
}
.n-emblem-text--size-xs {
  font-size: 10px;
}
.n-emblem-text--size-sm {
  font-size: 12px;
}
.n-emblem-text--size-md {
  font-size: 14px;
}
.n-emblem-text--size-lg {
  font-size: 18px;
  letter-spacing: -0.25px;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/emblem/EmblemText.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EACE,4BAAA;EACA,mBAAA;EACA,gBAAA;AASF;AAPE;EACE,mCAAA;AASJ;AANE;EACE,eAAA;AAQJ;AALE;EACE,eAAA;AAOJ;AAJE;EACE,eAAA;AAMJ;AAHE;EACE,eAAA;EACA,uBAAA;AAKJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import \"~venus\";\n\n.n-emblem-text {\n  color: var(--emblem-content);\n  line-height: normal;\n  font-weight: @fontWeight-semibold;\n\n  &--active {\n    color: var(--emblem-content-active);\n  }\n\n  &--size-xs {\n    font-size: @fontSize-xxs;\n  }\n\n  &--size-sm {\n    font-size: @fontSize-xs;\n  }\n\n  &--size-md {\n    font-size: @fontSize-sm;\n  }\n\n  &--size-lg {\n    font-size: @fontSize-md;\n    letter-spacing: -0.25px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
